// extracted by mini-css-extract-plugin
export default {"navBar":"Menu_navBar__kglkO","logoText":"Menu_logoText__k3tln","logoTextSmall":"Menu_logoTextSmall__Iukxi","titleText":"Menu_titleText__IGvfb"};